import { render, staticRenderFns } from "./CopyToTemplateCubage.vue?vue&type=template&id=a240e0c2"
import script from "./CopyToTemplateCubage.vue?vue&type=script&lang=js"
export * from "./CopyToTemplateCubage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports